import { useMediaQuery, useTheme } from 'libs/ui/theme';

export const useIsMobileSize = () => {
  const { theme } = useTheme();

  return useMediaQuery(theme.breakpoints.down('mobile'));
};
